'use strict';

var _ = require('lodash');
var StepSignificantMarketsController = function StepSignificantMarketsController($scope, $rootScope, cellRendererService) {
  $scope.stepTitle = 'Significant Markets';
  $scope.significanceOptions = [{
    label: 'Significant',
    value: 'true'
  }, {
    label: 'Insignificant',
    value: 'false'
  }];
  $scope.onSignificanceChange = function () {
    $scope.scheduleChange.updateSignificantEntities();
    $rootScope.$broadcast('scheduleChange:significanceChanged');
  };
  $scope.calculateGridHeight = function () {
    // Adding 1px to height to get rid of the vertical scrollbar
    $scope.height = $scope.defaultGridOptions.calculateGridHeight($scope.gridOptions.rowData.length, 10) + 1;
  };
  $scope.stepEntered = function (event, stepTitle) {
    if (stepTitle === $scope.stepTitle) {
      $scope.gridOptions.api.onNewRows();
      $scope.calculateGridHeight();
      $scope.gridOptions.api.sizeColumnsToFit();
    }
  };
  var significanceCellRenderer = function significanceCellRenderer(params) {
    return '<rm-segmented-radio-button input-name="market-significance" items="significanceOptions" ' + 'ng-click="onSignificanceChange()" ' + 'ng-model="scheduleChange.managedEntities[' + params.rowIndex + '].isSignificant">' + '</rm-segmented-button>';
  };
  var columnDefs = [{
    headerName: 'Market Name',
    field: 'market',
    cellRenderer: cellRendererService.marketCellRenderer,
    width: 267
  }, {
    headerName: 'Significance',
    field: 'isSignificant',
    cellRenderer: significanceCellRenderer,
    width: 195,
    cellClass: 'ag-cell-center'
  }];
  $scope.gridOptions = _.defaults({
    columnDefs: columnDefs,
    rowData: $scope.scheduleChange.managedEntities
  }, $scope.defaultGridOptions);
};
StepSignificantMarketsController.$inject = ['$scope', '$rootScope', 'CellRendererService'];
module.exports = StepSignificantMarketsController;